import { Menu as T } from "ant-design-vue"
import '@/assets/menu.less'
import i18n from "@/i18n/i18n"

const singleLineStyle = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }

export default {
  name: 'Menu',
  props: {
    ...T.props,
    /**
     * [
     *  {
     *    key: 菜单唯一标识
     *    name: 菜单名称
     *    menuType: 菜单类型， folder代表目录类型
     *    children: 子菜单列表
     *    path: 页面访问地址
     *  }
     * ]
     */
    tree: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    inHeader: Boolean,
  },
  model: {
    prop: 'selectedKeys',
    event: 'change'
  },
  data() {
    return {
      
    }
  },
  computed: {
    selectedParentKeys() {
      if (this.selectedKeys == null || this.selectedKeys.length == 0 || !this.tree?.length) {
        return []
      }
      const find = (list, key) => {
        let res = []
        for (const l of list) {
          if (l.key === key) {
            res.push(l)
          }
          if (l.children?.length) {
            const sub = find(l.children, key)
            res = res.concat(sub)
            if (sub && sub.length > 0) {
              res.push(l)
            }
          }
          if (l.tempchildren?.length) {
            const sub = find(l.tempchildren, key)
            res = res.concat(sub)
            if (sub && sub.length > 0) {
              res.push(l)
            }
          }
        }
        return res
      }
      let menus = []
      this.selectedKeys.forEach(k => {
        menus = menus.concat(find(this.tree, k))
      })
      const result = Array.from(new Set(menus.map(item => item.key)))
      return result
    }
  },
  methods: {
    renderMenu(item, h) {
      if (item.menuType === 'folder') {
        return this.renderSubMenu(item, h)
      }
      if (item.children && item.children.length > 0) {
        return this.renderSubMenu(item, h)
      }
      return this.renderMenuItem(item, h)
    },
    renderMenuItem(item, h) {
      const { handleAction } = this
      return h('a-menu-item', {
        props: {
          key: item.key,
        },
        class: ['menu-item', this.selectedKeys && this.selectedKeys.indexOf(item.key) >= 0 ? `menu-item-highlight-${this.theme}` : `menu-item-normal-${this.theme}`],
      }, [
        h('div', {
          style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          },
          on: {
            click: e => {
              e.preventDefault()
              handleAction(item, 'select')
            }
          }
        }, this.readonly ? [h('a-tooltip', { props: { placement: 'right' } }, [h('span', { style: { ...singleLineStyle } }, item.name), h('span', { slot: 'title' }, item.name)])] : [
          h('a-tooltip', { props: { placement: 'right' } }, [h('span', { style: { ...singleLineStyle } }, item.name), h('span', { slot: 'title' }, item.name)]),
          h('a-popover', {
            props: {
              trigger: 'hover',
              title: i18n.t('操作'),
              placement: 'right'
            }
          }, [
            h('a-icon', { 
              props: { type: 'ellipsis' },
              style: { 
                flexShrink: '0' 
              }
            }),
            h('div', { slot: 'content' }, [
              h('a-button', {
                props: {
                  type: 'link'
                },
                on: {
                  click: e => {
                    e.preventDefault()
                    handleAction(item, 'edit')
                  }
                },
                domProps: {
                  innerHTML: i18n.t('编辑')
                },
                style: {
                  display: 'block'
                }
              }),
              h('a-button', {
                props: {
                  type: 'link'
                },
                on: {
                  click: e => {
                    e.preventDefault()
                    handleAction(item, 'config')
                  }
                },
                domProps: {
                  innerHTML: i18n.t('设计')
                },
                style: {
                  display: 'block'
                }
              }),
              h('a-button', {
                props: {
                  type: 'link'
                },
                on: {
                  click: e => {
                    e.preventDefault()
                    handleAction(item, 'review')
                  }
                },
                domProps: {
                  innerHTML: i18n.t('页面说明')
                },
                style: {
                  display: 'block'
                }
              }),
              h('a-button', {
                props: {
                  type: 'link'
                },
                on: {
                  click: e => {
                    e.preventDefault()
                    handleAction(item, 'template')
                  }
                },
                domProps: {
                  innerHTML: i18n.t('消息模板')
                },
                style: {
                  display: 'block'
                }
              }),
              h('a-button', {
                props: {
                  type: 'link'
                },
                on: {
                  click: e => {
                    e.preventDefault()
                    handleAction(item, 'header')
                  }
                },
                domProps: {
                  innerHTML: i18n.t('API headers')
                },
                style: {
                  display: 'block'
                }
              }),
              h('a-button', {
                props: {
                  type: 'link'
                },
                on: {
                  click: e => {
                    e.preventDefault()
                    handleAction(item, 'delete')
                  }
                },
                domProps: {
                  innerHTML: i18n.t('删除')
                },
                style: {
                  display: 'block',
                  color: 'red'
                }
              }),
            ])
          ]),
        ])
      ])
    },
    renderSubMenu(item, h) {
      const subItems = item.children?.length ? item.children.map(c => {
        return this.renderMenu(c, h)
      }) : []
      const { handleAction } = this
      return h('a-sub-menu', {
        key: item.key,
        on: {
          titleClick: (event) => {
            handleAction(item, 'folder')
          }
        },
        class: [this.inHeader ? this.selectedParentKeys.indexOf(item.key) >= 0 ? `menu-header-title-highlight-${this.theme}` : `menu-header-title-normal-${this.theme}` : `menu-side-sub-${this.theme}`],
        props: {
          key: item.key,
          title: h('div', {
            style: {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: this.inHeader ? '64px' : undefined,
            }
          }, this.readonly ? [h('a-tooltip', { props: { placement: 'right' } }, [h('span', { style: { ...singleLineStyle, fontSize: this.inHeader ? '18px' : undefined, fontWight: this.inHeader ? '600' : undefined }, class: [`menu-title-${this.theme || 'light'}`] }, item.name), h('span', { slot: 'title' }, item.name)])] : [
            h('a-tooltip', { props: { placement: 'right' } }, [h('span', { style: { ...singleLineStyle, fontSize: this.inHeader ? '18px' : undefined, fontWight: this.inHeader ? '600' : undefined }, class: [`menu-title-${this.theme || 'light'}`] }, item.name), h('span', { slot: 'title' }, item.name)]),
            h('a-popover', {
              props: {
                trigger: 'hover',
                title: i18n.t('操作'),
                placement: 'right'
              }
            }, [
              h('a-icon', { 
                props: { type: 'ellipsis' },
                style: { 
                  flexShrink: '0' 
                }
              }),
              h('div', { slot: 'content' }, [
                h('a-button', {
                  props: {
                    type: 'link'
                  },
                  on: {
                    click: e => {
                      handleAction(item, 'edit')
                    }
                  },
                  domProps: {
                    innerHTML: i18n.t('编辑')
                  },
                  style: {
                    display: 'block'
                  }
                }),
                h('a-button', {
                  props: {
                    type: 'link'
                  },
                  on: {
                    click: e => {
                      handleAction(item, 'add')
                    }
                  },
                  domProps: {
                    innerHTML: i18n.t('新增子目录')
                  },
                  style: {
                    display: 'block'
                  }
                }),
                h('a-button', {
                  props: {
                    type: 'link'
                  },
                  on: {
                    click: e => {
                      handleAction(item, 'addPage')
                    }
                  },
                  domProps: {
                    innerHTML: i18n.t('新增子页面')
                  },
                  style: {
                    display: 'block'
                  }
                }),
                h('a-button', {
                  props: {
                    type: 'link'
                  },
                  on: {
                    click: e => {
                      handleAction(item, 'delete')
                    }
                  },
                  domProps: {
                    innerHTML: i18n.t('删除')
                  },
                  style: {
                    display: 'block',
                    color: 'red'
                  }
                }),
              ])
            ]),
          ])
        },
      }, subItems)
    },
    handleAction(item, action) {
      this.$emit('select', item, action)
    },
  },
  render(h) {
    if (this.tree.length == 0) {
      return null
    }
    const menuTree = this.tree.map(e => {
      return this.renderMenu(e, h)
    })
    const props = {}
    Object.keys(T.props).forEach(k => {
      if (this[k] !== undefined) {        
        props[k] = this[k]
      }
    })
    const theme = props.theme || 'light'
    const mode =  props.mode || 'inline'
    return h('a-menu', {
      props: {
        ...props,
        theme,
        mode
      },
      style: {
        backgroundColor: 'transparent'
      },
      on: {
        openChange: openKeys => {
          this.$emit('openChange', openKeys)
        }
      },
    }, menuTree)
  },
}